import {
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

const theme = createTheme({
  palette: {
    custom: {
      light: "#0c4b74",
      main: "#0c4b74",
      dark: "#0c4b74",
      contrastText: "#fff",
    },
  },
});

function MUIInput(props) {
  const {
    variant,
    label,
    onChange,
    value,
    type,
    disabled,
    required,
    error,
    name,
  } = props;
  return (
    <TextField
      fullWidth={true}
      variant={variant}
      disabled={disabled}
      label={label}
      value={value}
      type={type}
      required={required}
      onChange={onChange}
      error={error}
      name={name}
      InputLabelProps={{ shrink: true }}
    />
  );
}

function PasswordField(props) {
  const [showPassword, setShowPassword] = useState(false);
  const { label, name, value, onChange, error, required, variant } = props;

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      fullWidth
      variant={variant}
      type={showPassword ? "text" : "password"}
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      error={error}
      required={required}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleTogglePasswordVisibility}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

export { MUIInput, PasswordField };
